export default __webpack_public_path__ + "static/1-bd1618348c9fadc3fd11b8b48682a399.jpeg";